<template>
  <div class="main-container">
    <v-container class="pa-0" fluid>
      <div class="header-holder pl-3 pl-md-0 py-5">
        <h1 class="header">
          {{ $t("app_bar.title") }}
        </h1>
        <h4 class="sub-header">
          {{ $t("app_bar.university_name") }}
        </h4>
      </div>
      <LauncherTabs :page="page" />
      <v-card
        :disabled="loading"
        :loading="loading"
        color="rgb(255, 255, 255, 0.6)"
        class="pa-5"
      >
        <div class="black--text text-center pb-3">
          <h3>{{ $t("announcement.announcement_con") }}</h3>
        </div>
        <v-row>
          <v-col class="col-12 col-md-12" v-for="(item, i) in items" :key="i">
            <v-card :color="item.color" dark>
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title
                    class="text-decoration"
                    v-text="objectTranslator(item, 'title')"
                  ></v-card-title>

                  <v-card-subtitle
                    v-text="objectTranslator(item, 'detail')"
                  ></v-card-subtitle>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <div class="news-container pa-0 pa-sm-3 pa-xl-6">
          <v-card>
            <v-tabs v-model="tab" center-active dark>
              <v-tabs-slider color="brown"></v-tabs-slider>
              <v-tab
                href="#tab-1"
                class="font-weight-bold"
                style="background-color: #88e1ff"
              >
                {{ $t("announcement.application_announcement") }}
              </v-tab>
              <v-tab
                href="#tab-2"
                class="font-weight-bold"
                style="background-color: #ffec73"
              >
                {{ $t("announcement.writing_information") }}
              </v-tab>
              <v-tab
                href="#tab-3"
                class="font-weight-bold"
                style="background-color: #ffa956"
              >
                {{ $t("announcement.interview_information") }}
              </v-tab>
              <v-tab
                href="#tab-4"
                class="font-weight-bold"
                style="background-color: #ff68a9"
              >
                {{ $t("announcement.clearing_house") }}
              </v-tab>
              <v-tab
                href="#tab-5"
                class="font-weight-bold"
                style="background-color: #c8ff56"
              >
                {{ $t("announcement.qualified") }}
              </v-tab>
              <v-tab
                href="#tab-6"
                class="font-weight-bold"
                style="background-color: #c172ff"
              >
                {{ $t("announcement.matriculation") }}
              </v-tab>
            </v-tabs>
            <v-tabs-items
              class="pl-4"
              style="color: #fcaf1e"
              v-model="tab"
              touchless
              v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
            >
              {{ $t("announcement.swift") }}
            </v-tabs-items>
            <v-tabs-items v-model="tab" touchless>
              <v-tab-item
                v-for="(item_main, i) in news_type"
                :key="i"
                :value="item_main.tab_id"
              >
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>
                          {{ $t("announcement.title") }}
                        </th>
                        <th>
                          {{ $t("announcement.detail") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in item_main.type"
                        v-bind:key="item.news_id"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>
                          <a
                            v-bind:href="item.link1"
                            target="_blank"
                            style="text-decoration: none"
                            >{{
                              inlineTranslator({
                                en: item.topic_en,
                                th: item.topic,
                              })
                            }}</a
                          >
                          <br />
                          <div
                            style="
                              color: #a9a9a9;
                              font-size: 8pt;
                              text-align: right;
                            "
                          >
                            { {{ item.date_time }} }
                          </div>
                        </td>
                        <td>
                          <span v-if="item.link1 && item.link2">
                            <div class="d-flex">
                              <ButtonNews
                                v-bind:text="filetype(item.link1)"
                                v-bind:link="item.link1"
                                color="primary"
                                class="mr-1"
                              />

                              <ButtonNews
                                v-bind:text="filetype(item.link2)"
                                v-bind:link="item.link2"
                                color="primary"
                              />
                            </div>
                          </span>
                          <span v-else>
                            <ButtonNews
                              v-bind:text="$t('announcement.detail')"
                              v-bind:link="item.link1"
                              color="primary"
                              mdi="mdi-link-variant"
                            />
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { objectTranslator, inlineTranslator } from "@/helper/translator";
import ButtonNews from "@/components/announcement/ButtonNews";
import AnnouncementProvider from "@/services/announcement.provider";
import LauncherTabs from "@/components/explore_page/LauncherTabs";

const announcementProvider = new AnnouncementProvider();

export default {
  name: "AnnoucementCon",
  data: function () {
    return {
      page: "undergraduate_announcement",
      tab: null,
      index: 1,
      loading: false,

      newsCon_application: [],
      newsCon_writing: [],
      newsCon_interview: [],
      newsCon_clearing: [],
      newsCon_qualified: [],
      newsCon_confirm: [],

      items: [
        {
          color: "#952175",
          link: "/announcement_con",
          title_TH: "หลักสูตรต่อเนื่อง",
          detail_TH:
            "ประกาศรับสมัคร/ประกาศรายชื่อ หลักสูตรต่อเนื่อง สำหรับผู้จบ ปวส.",
          title_EN: "Continuing Program",
          detail_EN:
            "Announcement for Continuing Program Admission for High Vocational Certificate Graduates",
        },
      ],
    };
  },
  components: {
    LauncherTabs,
    ButtonNews,
  },
  methods: {
    objectTranslator,
    inlineTranslator,

    filetype: function (filename) {
      const re = /(?:\.([^.]+))?$/;
      return re.exec(filename)[1];
    },

    async fetch_data() {
      const data1 = await announcementProvider.getNewsCons_application({
        round: this.round,
      });
      this.newsCon_application = data1;

      const data2 = await announcementProvider.getNewsCons_writing({
        round: this.round,
      });
      this.newsCon_writing = data2;

      const data3 = await announcementProvider.getNewsCons_interview({
        round: this.round,
      });
      this.newsCon_interview = data3;

      const data4 = await announcementProvider.getNewsCons_clearing({
        round: this.round,
      });
      this.newsCon_clearing = data4;

      const data5 = await announcementProvider.getNewsCons_qualified({
        round: this.round,
      });
      this.newsCon_qualified = data5;

      const data6 = await announcementProvider.getNewsCons_confirm({
        round: this.round,
      });
      this.newsCon_confirm = data6;
    },
  },
  computed: {
    news_type() {
      return [
        {
          tab_id: "tab-1",
          type: this.newsCon_application,
        },
        {
          tab_id: "tab-2",
          type: this.newsCon_writing,
        },
        {
          tab_id: "tab-3",
          type: this.newsCon_interview,
        },
        {
          tab_id: "tab-4",
          type: this.newsCon_clearing,
        },
        {
          tab_id: "tab-5",
          type: this.newsCon_qualified,
        },
        {
          tab_id: "tab-6",
          type: this.newsCon_confirm,
        },
      ];
    },
  },
  mounted: function () {
    this.loading = true;
    this.fetch_data();
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.topic-container {
  background-color: #fffa;
  padding: 5px 25px 25px 25px;
  display: flex;
  flex-direction: column;
}
.main-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.header-holder {
  padding-bottom: 20px;
}

.header {
  color: rgb(255, 255, 255);
  text-shadow: 1px 1px 1px #000000cc;
  font-weight: bold;
}

.sub-header {
  color: #ff3c00;
  background-color: rgba(255, 255, 255, 0.5);
  // padding: 0px 10px 0px 10px;
  width: auto;
  font-weight: bold;
}

.news-container {
  background-color: #0005;
  // padding: 20px;
}

.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: rgba(0, 0, 0, 0.7);
}

.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--inactive) {
  color: rgba(0, 0, 0, 0.7);
}
</style>
